import Vue from 'vue';
import Vuetify, { VSnackbar, VBtn, VIcon } from 'vuetify/lib';

import ru from 'vuetify/es5/locale/ru';
import en from 'vuetify/es5/locale/en';
import colors from 'vuetify/lib/util/colors';

import { DARK_THEME_AUTO } from '@/config/features';
import { detectDarkMode } from '@/helpers/media';
import { getSavedTheme } from '@/helpers/theme';

Vue.use(Vuetify, {
  components: {
    VSnackbar,
    VBtn,
    VIcon,
  },
});

const dark = (DARK_THEME_AUTO && detectDarkMode()) || getSavedTheme();

export default new Vuetify({
  icons: {
    iconfont: 'md',
  },
  lang: {
    locales: { ru, en },
    current: 'ru',
  },
  theme: {
    dark,
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: colors.green.lighten1,
        warning: colors.orange.lighten3,
        info: colors.lightBlue.lighten1,
        lines: colors.grey.lighten3,
        background: '#f0f5f8',
        documents: colors.green.lighten5,
        borderDocuments: colors.green.lighten1,
        text: colors.blueGrey.darken2,
      },
      dark: {
        primary: colors.green.lighten1,
        warning: colors.orange.darken3,
        info: colors.lightBlue.lighten5,
        lines: colors.grey.darken3,
        background: colors.blueGrey.darken3,
        documents: colors.blueGrey.darken1,
        borderDocuments: colors.blueGrey.darken4,
        text: colors.blueGrey.lighten5,
      },
    },
  },
});
